module.exports = __webpack_public_path__ + "94517e8caf2e8262cf4872393aaddfe8.png";